import './App.scss'
import '@aws-amplify/ui-react/styles.css'
import React from 'react'
import { useTranslation } from 'react-i18next'
import CenteredContent from './CenteredContent'
import { WrongLocation as WrongLocationIcon } from '@mui/icons-material'
import { Typography } from '@mui/material'
import Box from '@mui/material/Box'
import { Link } from 'react-router-dom'

const Error404Page = () => {
  const { t } = useTranslation()

  return (
    <CenteredContent sx={{ marginX: 3 }}>
      <WrongLocationIcon fontSize="large" sx={{ marginRight: 3 }} />
      <Typography variant="h6">
        {t('errors.error404')}
        <Box sx={{ textAlign: 'center', marginTop: 1 }}>
          <Link to="/">{t('app.homeButton')}</Link>
        </Box>
      </Typography>
    </CenteredContent>
  )
}

export default Error404Page
